export class FolderCounterUpdatedEvent {
	public constructor(public count: number) {}
}
